import { createBrowserRouter } from 'react-router';
import { AskPage } from '../pages/ask/AskPage';
import { DashboardPage } from '../pages/dashboard/DashboardPage';
import { InboxPage } from '../pages/inbox/InboxPage';
import { LoginPage } from '../pages/login/LoginPage';
import { WxConfirmPage } from '../pages/login/WxConfirm';
import { MePage } from '../pages/me/MePage';
import { NotificationsPage } from '../pages/notifications/NotificationsPage';
import { OnboardingPage } from '../pages/Onboarding';
import { PersonPage } from '../pages/people/PersonPage';
import { ProjectPage } from '../pages/projects/ProjectPage';
import { ProgramPage } from '../pages/programs/ProgramPage';
import { ProgramsPage } from '../pages/programs/ProgramsPage';
import { RadarPage } from '../pages/radar/RadarPage';
import { SettingsPage } from '../pages/settings/SettingsPage';
import { TeamPage } from '../pages/team/TeamPage';
import { WeeklyPage } from '../pages/weekly/WeeklyPage';
import { ReportPage } from '../pages/report/ReportPage';
import { AppShell } from './AppShell';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/wx/confirm', element: <WxConfirmPage /> },
  { path: '/onboarding', element: <OnboardingPage /> },
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <ReportPage /> },
      { path: 'reports/:date', element: <ReportPage /> },
      { path: 'inbox', element: <InboxPage /> },
      { path: 'inbox/:id', element: <InboxPage /> },
      { path: 'notifications', element: <NotificationsPage /> },
      { path: 'projects', element: <RadarPage key="mine" scope="mine" /> },
      { path: 'projects/:id', element: <ProjectPage /> },
      { path: 'radar', element: <RadarPage key="all" scope="all" /> },
      { path: 'programs', element: <ProgramsPage /> },
      { path: 'programs/:id', element: <ProgramPage /> },
      { path: 'team', element: <TeamPage /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'ask', element: <AskPage /> },
      { path: 'teams/:id', element: <RadarPage key="team" scope="all" /> },
      { path: 'people/:id', element: <PersonPage /> },
      { path: 'weekly', element: <WeeklyPage /> },
      { path: 'weekly/:week', element: <WeeklyPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'settings/:section', element: <SettingsPage /> },
      { path: 'me', element: <MePage /> },
    ],
  },
]);
